const e=(e,t,n)=>{globalThis.dispatchEvent(new CustomEvent(e,{detail:{purpose:n,newApiKey:t}}))};export{e as dispatchSearchKeyUpdatedWindowEvent};
